__webpack_require__.p = "/cua/assets/apps/careers-ui/";